module.exports = __webpack_public_path__ + "static/media/intro-bg.b28baa89.jpg";